import styled from "styled-components";
import { palette, typography } from "@src/core/styles";

export const QueryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  ${typography.body_medium_regular};

  th,
  td {
    padding: 8px 14px;
    text-align: left;
    border-bottom: 1px solid ${palette.colors.outline_variant};
    vertical-align: top;
  }

  th {
    background-color: ${palette.colors.surface_container};
    font-weight: 500;
    color: ${palette.colors.onsurface_variant};
  }

  td code {
    font-family: "JetBrains Mono", "Fira Code", "Courier New", monospace;
    font-size: 13px;
    word-break: break-all;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const PartsGrid = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 8px 16px;
  padding: 14px;

  dt {
    ${typography.body_medium_regular};
    color: ${palette.colors.onsurface_variant};
  }

  dd {
    ${typography.body_medium_regular};
    font-family: "JetBrains Mono", "Fira Code", "Courier New", monospace;
    font-size: 13px;
    color: ${palette.colors.onsurface};
    margin: 0;
    word-break: break-all;
  }
`;
